export default {
  activeCoords: null,
  activeLayerId: null,
  bounds: null,
  layers: [],
  targetMarkerLayer: '',
  mapMarkers: [],
  zoom: null,
  style: {}
}
